import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';

import { type DefinitionMapper } from '../../../ai';
import { NumberType } from '../../../ai/models/chart';

import { type ValueChartDefinition } from './value-chart.definition';

export class ValueChartDefinitionMapper implements DefinitionMapper<'chartSingle'> {
  readonly type = 'chartSingle';

  extract(element: CanvasElementFrom<'chartSingle'>): PartialDeep<ValueChartDefinition> {
    const content = element.props.content;

    return {
      title: content.title?.label,
      showTitle: content.title?.enabled,
      iconName: content.title?.icon,
      format: this.getAxisFormat(element),
      precision: content.format?.precision,
    };
  }

  protected getAxisFormat(element: CanvasElementFrom<'chartSingle'>): NumberType | undefined {
    switch (element.props.content.format?.type) {
      case 'Currency':
        return NumberType.Currency;
      case 'Percent':
        return NumberType.Percent;
      case 'Number':
        return NumberType.Number;
      default:
        return undefined;
    }
  }
}
